import React from 'react';
import { FileText, Image, Video, File } from 'lucide-react';
import { FileAttachment } from '@/services/apis/guide-ai-chat';
import { Card, CardBody, Chip, Button } from '@heroui/react';

interface ChatAttachmentProps {
  attachment: FileAttachment;
  onRemove?: () => void;
}

const ChatAttachment: React.FC<ChatAttachmentProps> = ({ attachment, onRemove }) => {
  const getIcon = () => {
    if (attachment.type.startsWith('image/')) {
      return <Image className="w-4 h-4" />;
    }
    if (attachment.type.startsWith('video/')) {
      return <Video className="w-4 h-4" />;
    }
    if (attachment.type === 'application/pdf') {
      return <FileText className="w-4 h-4" />;
    }
    return <File className="w-4 h-4" />;
  };

  const getColor = () => {
    if (attachment.type.startsWith('image/')) return 'primary';
    if (attachment.type.startsWith('video/')) return 'secondary';
    if (attachment.type === 'application/pdf') return 'danger';
    return 'default';
  };

  return (
    <Card className="border border-gray-200 dark:border-gray-700 shadow-sm">
      <CardBody className="p-2">
        <div className="flex items-center gap-2">
          <Chip
            size="sm"
            variant="flat"
            color={getColor()}
            startContent={getIcon()}
            classNames={{
              base: 'flex-shrink-0',
            }}
          />
          <span className="text-sm font-medium truncate max-w-[200px] text-gray-700 dark:text-gray-300">
            {attachment.name}
          </span>
          {onRemove && (
            <Button
              isIconOnly
              size="sm"
              variant="light"
              className="ml-auto min-w-0 w-5 h-5"
              onPress={onRemove}
              aria-label="Remove attachment"
            >
              ×
            </Button>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default ChatAttachment;

